if (!customElements.get('product-note')) {
  customElements.define('product-note', class ProductNote extends BaseElement {
    constructor()
    {
      super();

      this.data = null;
      this.productCard = this.closest('product-card');
      this.donorCard = this.closest('.donor-card');

      this.onBroadcast('notes', data => {
        this.updateWithData(data);
      });
    }

    updateWithData(data)
    {
      this.data = data;
      this.update();
    }

    update()
    {
      if (!this.data) {
        this.classList.remove('has-note');
        this.querySelector('.product-card-note--value').innerHTML = '';

        return;
      }

      let found = false;

      this.data.forEach(note => {
        if (note.product_id.split('/')[4] == this.getId()) {
          this.querySelector('.product-card-note--value').innerHTML = note.note;
          this.classList.add('has-note');
          found = true;
        }
      });

      if (!found) {
        this.classList.remove('has-note');
        this.querySelector('.product-card-note--value').innerHTML = ''
      }
    }

    getId ()
    {
      if (typeof(this.dataset.productId) !== 'undefined') {
        return this.dataset.productId;
      }

      if (this.productCard) {
        return typeof(this.productCard.dataset.productCardId) !== 'undefined'
          ? this.productCard.dataset.productCardId
          : null;
      }

      if (this.donorCard) {
        return typeof(this.donorCard.dataset.productId) !== 'undefined'
          ? this.donorCard.dataset.productId
          : null;
      }

      return null;
    }
  })
}

if (!customElements.get('product-note-button')) {
  customElements.define('product-note-button', class ProductNoteButton extends BaseElement
  {
    constructor()
    {
      super();

      this.data = null;
      this.productCard = this.closest('product-card');
      this.donorCard = this.closest('.donor-card');

      this.addEventListener('click', e => {
        if (this.classList.contains('logged-out') || this.classList.contains('loading')) {
          return false;
        }

        e.preventDefault();

        this.open();
      });

      this.onBroadcast('notes', data => {
        this.updateWithData(data);
      });

      this.onBroadcast('noteLoadingStart', id => {
        if (id == this.getId()) {
          this.classList.add('loading');
        }
      });

      this.onBroadcast('noteLoadingEnd', id => {
        if (id == this.getId()) {
          this.classList.remove('loading');
        }
      });
    }

    async updateWithData (data)
    {
      this.data = data;
      await this.update();
    }

    async update ()
    {
      if (this.classList.contains('loading')) {
        return;
      }

      let found = false;

      if (this.data) {
        this.data.forEach(note => {
          if (note.product_id.split('/')[4] == this.getId()) {
            found = true;
          }
        });
      }

      if (found) {
        this.classList.add('has-note');
      } else {
        this.classList.remove('has-note');
      }
    }

    open ()
    {
      document.querySelector('custom-popup-notes')?.open(this.getId(), false);
    }

    getId ()
    {
      if (typeof(this.dataset.productId) !== 'undefined') {
        return this.dataset.productId;
      }

      if (this.productCard) {
        return typeof(this.productCard.dataset.productCardId) !== 'undefined'
          ? this.productCard.dataset.productCardId
          : null;
      }

      if (this.donorCard) {
        return typeof(this.donorCard.dataset.productId) !== 'undefined'
          ? this.donorCard.dataset.productId
          : null;
      }

      return null;
    }
  });
}